var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapLocation = function SvgMapLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.679c0 1.607-2.8 4.821-2.8 4.821S8 10.286 8 8.679C8.1 7.179 9.3 6 10.8 6c1.4 0 2.6 1.179 2.7 2.679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 8.714a.25.25 0 0 1 0-.5M10.75 8.714a.25.25 0 1 0 0-.5M4.497 11.577l-2.772.64A1 1 0 0 1 .5 11.243V2.218a1 1 0 0 1 .775-.974L4.497.5zM8.503 4.5V1.423L4.497.5v11.077L7 12.154M12.5 4V1.757a1 1 0 0 0-1.225-.974l-2.772.64"
  }))));
};
export default SvgMapLocation;